export default __webpack_public_path__ + "static/media/searchbar.7ec57d04.svg";